import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import MLMHero from "./MLMHero";
import Comprehensive from "./Comprehensive";
import MLMPlans from "./MLMPlans";
import EmpowerMLM from "./EmpowerMLM";
import AutomatedSystem from "./AutomatedSystem";
import MLMScripts from "./MLMScripts";
import MLMDevProcess from "./MLMDevProcess";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";

function MLM() {
  return (
    <div>
      <Header />
      <MLMHero />
      <Comprehensive />
      <MLMPlans />
      <EmpowerMLM />
      <AutomatedSystem />
      <MLMScripts />
      <MLMDevProcess />
      <BlockchainExpertise />
      <Footer />
    </div>
  );
}

export default MLM;
